"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEndUserRoutes = exports.pageToEntityMap = exports.pageToPathMap = void 0;
const CachedAsset_query_graphql_1 = __importDefault(require("@aurora/shared-apollo/resolvers/assets/CachedAsset.query.graphql"));
const assets_1 = require("@aurora/shared-types/assets");
const enums_1 = require("@aurora/shared-types/nodes/enums");
const enums_2 = require("@aurora/shared-types/overrides/enums");
const log_1 = require("@aurora/shared-utils/log");
const RoutesCache_1 = require("./RoutesCache");
exports.pageToPathMap = {
    BlogBoardPage: 'blogs/BlogBoardPage/BlogBoardPage',
    BlogEditPage: 'forums/PostPage/PostPage',
    BlogMessagePage: 'blogs/BlogMessagePage/BlogMessagePage',
    BlogPostPage: 'forums/PostPage/PostPage',
    BlogReplyPage: 'blogs/BlogMessagePage/BlogMessagePage',
    IdeaBoardPage: 'ideas/IdeaBoardPage/IdeaBoardPage',
    IdeaEditPage: 'forums/PostPage/PostPage',
    IdeaPostPage: 'forums/PostPage/PostPage',
    IdeaMessagePage: 'ideas/IdeaMessagePage/IdeaMessagePage',
    IdeaReplyPage: 'ideas/IdeaMessagePage/IdeaMessagePage',
    CategoryPage: 'community/CategoryPage/CategoryPage',
    ClosedMembershipNodeNonMembersPage: 'membership/ClosedMembershipNodeNonMembersPage/ClosedMembershipNodeNonMembersPage',
    CommunityPage: 'community/CommunityPage/CommunityPage',
    CreateGroupHubPage: 'grouphubs/CreateGroupHubPage/CreateGroupHubPage',
    EditGroupHubPage: 'grouphubs/EditGroupHubPage/EditGroupHubPage',
    ForgotPasswordPage: 'authentication/ForgotPasswordPage/ForgotPasswordPage',
    ForumBoardPage: 'forums/ForumBoardPage/ForumBoardPage',
    ForumEditPage: 'forums/PostPage/PostPage',
    ForumMessagePage: 'forums/ForumMessagePage/ForumMessagePage',
    ForumPostPage: 'forums/PostPage/PostPage',
    ForumReplyPage: 'forums/ForumMessagePage/ForumMessagePage',
    GroupHubMembershipAction: '',
    GroupHubPage: 'grouphubs/GroupHubPage/GroupHubPage',
    GroupHubPostPage: 'forums/PostPage/PostPage',
    GroupHubsPage: 'grouphubs/GroupHubsPage/GroupHubsPage',
    HelpFAQPage: 'help/HelpFAQPage/HelpFAQPage',
    InboxPage: 'inbox/InboxPage/InboxPage',
    LoginPage: 'authentication/LoginPage/LoginPage',
    ManageContentPage: 'managecontent/ManageContentPage/ManageContentPage',
    ManageMembersPage: 'members/ManageMembersPage/ManageMembersPage',
    ManageUsersPage: 'users/ManageUsersPage/ManageUsersPage',
    NotificationPage: 'notifications/NotificationPage/NotificationPage',
    PageEditorPage: 'pageeditor/PageEditorPage/PageEditorPage',
    PostPage: 'forums/PostPage/PostPage',
    RegistrationPage: 'authentication/RegistrationPage/RegistrationPage',
    ResetPasswordPage: 'authentication/ResetPasswordPage/ResetPasswordPage',
    SearchResultsPage: 'search/SearchResultsPage/SearchResultsPage',
    TagPage: 'tags/TagPage/TagPage',
    TermsOfServicePage: 'termsofservice/TermsOfServicePage/TermsOfServicePage',
    ThemeEditorPage: 'themeeditor/ThemeEditorPage/ThemeEditorPage',
    TkbBoardPage: 'kbs/TkbBoardPage/TkbBoardPage',
    TkbEditPage: 'forums/PostPage/PostPage',
    TkbMessagePage: 'kbs/TkbMessagePage/TkbMessagePage',
    TkbPostPage: 'forums/PostPage/PostPage',
    TkbReplyPage: 'kbs/TkbMessagePage/TkbMessagePage',
    UserPage: 'users/UserPage/UserPage',
    UserBadgesPage: 'badges/UserBadgesPage/UserBadgesPage',
    UserSettingsPage: 'users/UserSettingsPage/UserSettingsPage',
    VerifyUserEmailPage: 'authentication/VerifyUserEmailPage/VerifyUserEmailPage',
    BlogViewAllPostsPage: 'blogs/BlogViewAllPostsPage/BlogViewAllPostsPage',
    ForumViewAllTopicsPage: 'forums/ForumViewAllTopicsPage/ForumViewAllTopicsPage',
    TkbViewAllArticlesPage: 'kbs/TkbViewAllArticlesPage/TkbViewAllArticlesPage',
    IdeaViewAllIdeasPage: 'ideas/IdeaViewAllIdeasPage/IdeaViewAllIdeasPage',
    EventBoardPage: 'events/EventBoardPage/EventBoardPage',
    EventPostPage: 'forums/PostPage/PostPage',
    OccasionMessagePage: 'events/OccasionMessagePage/OccasionMessagePage',
    OccasionReplyPage: 'events/OccasionMessagePage/OccasionMessagePage',
    CustomPage: 'custom/CustomPage/CustomPage',
    AllOccasionsPage: 'events/AllOccasionsPage/AllOccasionsPage',
    OccasionEditPage: 'forums/PostPage/PostPage',
    CasePortalPage: 'salesforce/CasePortalPage/CasePortalPage',
    CaseCreatePage: 'salesforce/CaseCreatePage/CaseCreatePage',
    CaseViewPage: 'salesforce/CaseViewPage/CaseViewPage',
    OccasionRsvpActionPage: '',
    OAuthAuthorizationAllowPage: 'authentication/OAuthAuthorizationAllowPage/OAuthAuthorizationAllowPage',
    MaintenancePage: 'maintenance/MaintenancePage/MaintenancePage',
    CommunityGuideLinesPage: 'communityguidelines/CommunityGuideLinesPage/CommunityGuideLinesPage',
    PrivacyPolicyPage: 'privacypolicy/PrivacyPolicyPage/PrivacyPolicyPage'
};
exports.pageToEntityMap = {
    BlogBoardPage: enums_1.EntityType.BLOG,
    BlogEditPage: enums_1.EntityType.BLOG,
    BlogMessagePage: enums_1.EntityType.BLOG_ARTICLE,
    BlogPostPage: enums_1.EntityType.BLOG,
    BlogReplyPage: enums_1.EntityType.BLOG_REPLY,
    IdeaBoardPage: enums_1.EntityType.IDEA,
    IdeaEditPage: enums_1.EntityType.IDEA,
    IdeaPostPage: enums_1.EntityType.IDEA,
    IdeaMessagePage: enums_1.EntityType.IDEA_POST,
    IdeaReplyPage: enums_1.EntityType.IDEA_REPLY,
    CategoryPage: enums_1.EntityType.CATEGORY,
    ClosedMembershipNodeNonMembersPage: enums_1.EntityType.GROUP_HUB,
    CommunityPage: enums_1.EntityType.COMMUNITY,
    CreateGroupHubPage: enums_1.EntityType.COMMUNITY,
    CustomPage: enums_1.EntityType.COMMUNITY,
    EditGroupHubPage: enums_1.EntityType.GROUP_HUB,
    ForgotPasswordPage: enums_1.EntityType.COMMUNITY,
    ForumBoardPage: enums_1.EntityType.FORUM,
    ForumEditPage: enums_1.EntityType.FORUM,
    ForumMessagePage: enums_1.EntityType.FORUM_TOPIC,
    ForumPostPage: enums_1.EntityType.FORUM,
    ForumReplyPage: enums_1.EntityType.FORUM_REPLY,
    GroupHubMembershipAction: enums_1.EntityType.GROUP_HUB,
    GroupHubPage: enums_1.EntityType.GROUP_HUB,
    GroupHubPostPage: enums_1.EntityType.GROUP_HUB,
    GroupHubsPage: enums_1.EntityType.COMMUNITY,
    HelpFAQPage: enums_1.EntityType.COMMUNITY,
    InboxPage: enums_1.EntityType.COMMUNITY,
    LoginPage: enums_1.EntityType.COMMUNITY,
    ManageContentPage: enums_1.EntityType.COMMUNITY,
    ManageMembersPage: enums_1.EntityType.GROUP_HUB,
    ManageUsersPage: enums_1.EntityType.COMMUNITY,
    NotificationPage: enums_1.EntityType.COMMUNITY,
    PageEditorPage: enums_1.EntityType.COMMUNITY,
    PostPage: enums_1.EntityType.COMMUNITY,
    RegistrationPage: enums_1.EntityType.COMMUNITY,
    ResetPasswordPage: enums_1.EntityType.COMMUNITY,
    SearchResultsPage: enums_1.EntityType.COMMUNITY,
    TagPage: enums_1.EntityType.COMMUNITY,
    TermsOfServicePage: enums_1.EntityType.COMMUNITY,
    ThemeEditorPage: enums_1.EntityType.COMMUNITY,
    TkbBoardPage: enums_1.EntityType.TKB,
    TkbEditPage: enums_1.EntityType.TKB,
    TkbMessagePage: enums_1.EntityType.TKB_ARTICLE,
    TkbPostPage: enums_1.EntityType.TKB,
    TkbReplyPage: enums_1.EntityType.TKB_REPLY,
    UserBadgesPage: enums_1.EntityType.COMMUNITY,
    UserPage: enums_1.EntityType.COMMUNITY,
    UserSettingsPage: enums_1.EntityType.COMMUNITY,
    VerifyUserEmailPage: enums_1.EntityType.COMMUNITY,
    BlogViewAllPostsPage: enums_1.EntityType.COMMUNITY,
    ForumViewAllTopicsPage: enums_1.EntityType.COMMUNITY,
    TkbViewAllArticlesPage: enums_1.EntityType.COMMUNITY,
    IdeaViewAllIdeasPage: enums_1.EntityType.COMMUNITY,
    EventBoardPage: enums_1.EntityType.EVENT,
    EventPostPage: enums_1.EntityType.EVENT,
    OccasionMessagePage: enums_1.EntityType.OCCASION_TOPIC,
    OccasionReplyPage: enums_1.EntityType.OCCASION_REPLY,
    AllOccasionsPage: enums_1.EntityType.COMMUNITY,
    OccasionEditPage: enums_1.EntityType.EVENT,
    CasePortalPage: enums_1.EntityType.COMMUNITY,
    CaseCreatePage: enums_1.EntityType.COMMUNITY,
    CaseViewPage: enums_1.EntityType.COMMUNITY,
    OccasionRsvpActionPage: enums_1.EntityType.OCCASION_TOPIC,
    OAuthAuthorizationAllowPage: enums_1.EntityType.COMMUNITY,
    CommunityGuideLinesPage: enums_1.EntityType.COMMUNITY,
    PrivacyPolicyPage: enums_1.EntityType.COMMUNITY,
    MaintenancePage: enums_1.EntityType.COMMUNITY
};
/**
 * Gets or builds the end user routes for the specified base path.
 *
 * @param tenant the tenant
 * @param client the apollo client.
 * @param lastModified last modified timestamp of pages.
 */
const log = (0, log_1.getLog)(module);
function getEndUserRoutes(tenant, client, lastModified) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function* () {
        const routesCache = (0, RoutesCache_1.getRoutesCacheInstance)();
        try {
            const { data, error, errors } = yield client.query({
                query: CachedAsset_query_graphql_1.default,
                variables: {
                    assetId: 'pages',
                    assetType: enums_2.CachedAssetType.PAGES,
                    lastModified: lastModified !== null && lastModified !== void 0 ? lastModified : assets_1.LastModifiedKeys.USE_CACHED
                },
                context: {
                    tenant
                }
            });
            if (errors || error) {
                log.error(errors || error, 'Error getting enduser routes');
            }
            else {
                const pages = (_b = (_a = data === null || data === void 0 ? void 0 : data.cachedAsset) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : [];
                const lastUpdatedTime = (_d = (_c = data === null || data === void 0 ? void 0 : data.cachedAsset) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : assets_1.LastModifiedKeys.USE_CACHED;
                const localOverride = (_f = (_e = data === null || data === void 0 ? void 0 : data.cachedAsset) === null || _e === void 0 ? void 0 : _e.localOverride) !== null && _f !== void 0 ? _f : false;
                return routesCache.buildRoutes(tenant, {
                    pages,
                    lastModified: lastUpdatedTime,
                    localOverride
                });
            }
        }
        catch (error) {
            log.error(error, 'Network error getting enduser routes');
        }
        return routesCache.buildRoutes(tenant, { pages: [], lastModified, localOverride: false });
    });
}
exports.getEndUserRoutes = getEndUserRoutes;
//# sourceMappingURL=endUserRoutes.js.map